import script from "./Pair.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pair.vue?vue&type=script&setup=true&lang=ts"

import "./Pair.vue?vue&type=style&index=0&id=4ecab887&lang=css"

const __exports__ = script;

export default __exports__